module.exports = require("./cgg.d.ts");